"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderNav = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("./Button");
const Div_1 = require("./Div");
const constants_1 = require("../constants");
const Nav = styled_1.default.nav `
  display: flex;
  align-items: center;
  position: relative;
  background-color: ${constants_1.Color.BLUE};
  color: ${constants_1.Color.WHITE};
  padding: ${constants_1.theme.spacing[1]}px;
  min-height: 50px;
`;
const Start = (0, styled_1.default)(Div_1.Div) `
  z-index: 1;
`;
const Middle = (0, styled_1.default)(Div_1.Div) `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  padding-left: 90px;
  padding-right: 90px;
`;
const End = (0, styled_1.default)(Div_1.Div) `
  z-index: 1;
  margin-left: auto;
`;
const HeaderNav = ({ className, slotStart, slotMiddle, slotEnd, }) => {
    return ((0, jsx_runtime_1.jsxs)(Nav, { className: className, children: [slotStart && (0, jsx_runtime_1.jsx)(Start, { children: slotStart }), slotMiddle && (0, jsx_runtime_1.jsx)(Middle, { children: slotMiddle }), slotEnd && (0, jsx_runtime_1.jsx)(End, { children: slotEnd })] }));
};
exports.HeaderNav = HeaderNav;
HeaderNav.Title = styled_1.default.h1 `
  font-size: ${constants_1.theme.font.size[3]}px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
HeaderNav.Button = (0, styled_1.default)(Button_1.Button) ``;
